// Genel Parametre (Setting Key/Value) okuma yardımcıları.
// Değerler backend'de string olarak saklanır (SettingsController.SaveByKey);
// okuma OData GET /api/settings?$filter=Key eq '...' ile yapılır.

// #259 Oturum hareketsizlik zaman aşımı (dakika) — Genel Parametreler'den ayarlanır.
export const SETTING_SESSION_IDLE_MINUTES = 'Session.IdleTimeoutMinutes';

// #265 Müşteri KVKK onay süreci aktif mi? Açıksa yeni müşteri "Onaysız" doğar
// (hassas alanlar onaya kadar maskeli), kapalıysa "Onaylı" doğar (maskeleme yok).
export const SETTING_CUSTOMER_KVKK_ENABLED = 'Customer.KvkkEnabled';

// ── KULLANICI_YETKI_YONETIMI §10.4.1 · güvenlik parametreleri ──
// Tümü Setting satırıdır; Tenant tablosuna kolon EKLENMEZ (§7.12 revizyonu). Ayrı bir parametre
// yönetimi modülü kurulmadığı için (G-Y-06/G-Y-07 kapsam dışı) tek yer Genel Parametreler ekranıdır.

// Güvenlik / Oturum
export const SETTING_SINGLE_SESSION = 'SECURITY.SINGLE_SESSION';                 // G-L-06 / KK-05
export const SETTING_ACCESS_TOKEN_MINUTES = 'SECURITY.ACCESS_TOKEN_MINUTES';     // G-L-04
export const SETTING_REFRESH_TOKEN_DAYS = 'SECURITY.REFRESH_TOKEN_DAYS';         // G-L-04

// §14.1 — yetki kapısının fail-closed'a geçiş anahtarı. Sunucu tarafı karşılığı:
// MenuActionAuthorizer.StrictAuthorizationKey. Varsayılan KAPALI; tenant bazında açılır.
export const SETTING_STRICT_AUTHORIZATION = 'SECURITY.STRICT_AUTHORIZATION';     // G-Y-04 / §14.1

// Şifre Politikası
export const SETTING_PASSWORD_POLICY_LEVEL = 'SECURITY.PASSWORD_POLICY_LEVEL';   // Tenant kartından taşındı
export const SETTING_PASSWORD_EXPIRY_DAYS = 'SECURITY.PASSWORD_EXPIRY_DAYS';     // G-L-10
export const SETTING_PASSWORD_HISTORY_COUNT = 'SECURITY.PASSWORD_HISTORY_COUNT'; // G-L-10
export const SETTING_MAX_FAILED_ATTEMPTS = 'SECURITY.MAX_FAILED_ATTEMPTS';       // G-L-01
export const SETTING_LOCKOUT_MINUTES = 'SECURITY.LOCKOUT_MINUTES';               // G-L-01
export const SETTING_CAPTCHA_AFTER_ATTEMPTS = 'SECURITY.CAPTCHA_AFTER_ATTEMPTS'; // G-L-08

// Kimlik Doğrulama
export const SETTING_ALLOW_LOCAL_PASSWORD_LOGIN = 'SECURITY.ALLOW_LOCAL_PASSWORD_LOGIN'; // G-L-12 / KK-06
export const SETTING_TWO_FACTOR_MODE = 'SECURITY.TWO_FACTOR_MODE';               // G-L-07
export const SETTING_TWO_FACTOR_CHANNEL = 'SECURITY.TWO_FACTOR_CHANNEL';         // G-L-07

// Giriş Gün ve Saat Kısıtı (KK-16)
export const SETTING_LOGIN_WINDOW_ENABLED = 'SECURITY.LOGIN_WINDOW_ENABLED';
export const SETTING_LOGIN_WINDOW_CRITERIA_TYPE = 'SECURITY.LOGIN_WINDOW_CRITERIA_TYPE';
export const SETTING_LOGIN_WINDOW_CRITERIA = 'SECURITY.LOGIN_WINDOW_CRITERIA';
export const SETTING_LOGIN_WINDOW_DAYS = 'SECURITY.LOGIN_WINDOW_DAYS';
export const SETTING_LOGIN_WINDOW_START = 'SECURITY.LOGIN_WINDOW_START';
export const SETTING_LOGIN_WINDOW_END = 'SECURITY.LOGIN_WINDOW_END';
// Kısıt saatlerinin yorumlandığı saat dilimi. Sunucu Linux container'da UTC koşuyor; bu ayar
// olmadan girilen saatler 3 saat kaymış uygulanıyordu.
export const SETTING_LOGIN_WINDOW_TIMEZONE = 'SECURITY.LOGIN_WINDOW_TIMEZONE';

// Kullanıcı Yaşam Döngüsü
export const SETTING_INACTIVE_USER_DAYS = 'SECURITY.INACTIVE_USER_DAYS';         // G-K-03

// #45 Destek — canlı desteğin mesai penceresi ve bildirim alacak personel.
// Anahtar adları sunucudaki SupportAvailabilityService / SupportTicketService sabitleriyle
// BİREBİR aynı olmalıdır; ayar satırı yokken sunucu varsayılana düşer (hafta içi 09:00-18:00).
export const SETTING_SUPPORT_WORKING_DAYS = 'Support.WorkingDays';
export const SETTING_SUPPORT_HOURS_START = 'Support.WorkingHoursStart';
export const SETTING_SUPPORT_HOURS_END = 'Support.WorkingHoursEnd';
export const SETTING_SUPPORT_TIMEZONE = 'Support.TimeZone';
export const SETTING_SUPPORT_AGENT_USER_IDS = 'Support.AgentUserIds';

// Mobil / Cihaz
// Android kapısının ölçütü: cihazın API seviyesi (Build.VERSION.SDK_INT). Sayısal saklanır.
export const SETTING_MIN_ANDROID_API_LEVEL = 'MOBILE.MIN_ANDROID_API_LEVEL';
// KULLANILMIYOR — Android kapısı API seviyesine geçti. Anahtar, eski değeri olan kurulumlarda
// veriyi kaybetmemek için duruyor; hiçbir kararı etkilemiyor.
export const SETTING_MIN_APP_VERSION_ANDROID = 'MOBILE.MIN_APP_VERSION_ANDROID'; // G-L-14
export const SETTING_MIN_APP_VERSION_IOS = 'MOBILE.MIN_APP_VERSION_IOS';         // G-L-14
export const SETTING_BLOCK_ON_OLD_VERSION = 'MOBILE.BLOCK_ON_OLD_VERSION';       // G-L-14

// ── #809 BULUNURLUK saklama politikası ──
// Sunucu karşılığı: ProductAvailabilityRetentionJob.RetentionDaysKey / MaxRowsPerRunKey.
// Bulunurluk tablosu her ziyarette KATALOG KADAR satır yazar (tam snapshot) ve gecelik job
// bu parametreye göre eski satırları aylık özete indirip siler.
// Varsayılan 180 gün bir İŞ KARARIDIR: raporlama ihtiyacı bulunurluk TRENDİ olduğu için
// birkaç aylık ham geçmiş yeter; daha eskisi zaten aylık özetten okunur.
// Job 30 günün ALTINI uygulamaz (yanlış girilmiş küçük bir değer tüm geçmişi silerdi).
export const SETTING_PRODUCT_AVAILABILITY_RETENTION_DAYS = 'RETENTION.PRODUCT_AVAILABILITY_DAYS';
export const SETTING_PRODUCT_AVAILABILITY_MAX_ROWS = 'RETENTION.PRODUCT_AVAILABILITY_MAX_ROWS';

// ── #44 EKİP MESAJLAŞMASI saklama politikası ──
// Sunucu karşılığı: TeamChatRetentionJob.MessageRetentionDaysKey / ViolationRetentionDaysKey.
// İKİ AYRI SÜRE bilinçlidir: mesaj sohbet metnidir (operasyonel değeri kısa ömürlü), ihlal
// kaydı DENETİM izidir ve daha uzun tutulur. Aynı süreye bağlanırsa yasaklı kelime
// kullanımının izi, hakkında işlem yapılmadan önce silinebilirdi.
// Alt sınırlar job'da uygulanır: mesaj 30, ihlal 90 gün.
export const SETTING_TEAM_CHAT_MESSAGE_RETENTION_DAYS = 'RETENTION.TEAM_CHAT_MESSAGE_DAYS';
export const SETTING_TEAM_CHAT_VIOLATION_RETENTION_DAYS = 'RETENTION.TEAM_CHAT_VIOLATION_DAYS';

// Setting satırının ham (string) değerini okur. Satır yoksa null döner — çağıran default'u kendi verir.
// select / multiselect / time tipleri bunun üstüne kurulur.
export async function fetchRawSetting(key, headers) {
  try {
    const url = `/api/settings?$filter=${encodeURIComponent(`Key eq '${key}'`)}&$top=1`;
    const res = await fetch(url, { headers });
    if (res.ok) {
      const j = await res.json();
      const rows = j?.value || j?.data || j?.Data || (Array.isArray(j) ? j : []);
      const v = rows[0]?.value ?? rows[0]?.Value;
      if (v != null && v !== '') return String(v);
    }
  } catch { /* sessiz */ }
  return null;
}

// Bir sayısal Setting'i okur; satır yoksa/geçersizse defaultVal döner.
export async function fetchNumberSetting(key, headers, defaultVal = 0) {
  const v = await fetchRawSetting(key, headers);
  if (v != null) {
    const n = Number(v);
    if (Number.isFinite(n)) return n;
  }
  return defaultVal;
}

// Metin (select / time / serbest metin) Setting'i okur.
export async function fetchTextSetting(key, headers, defaultVal = '') {
  const v = await fetchRawSetting(key, headers);
  return v != null ? v : defaultVal;
}

// Çoklu seçim Setting'i okur. DB'de virgülle ayrılmış tek string olarak saklanır
// (ayrı tablo açmamak için — KK-16 kriter listesi ve gün listesi bu biçimdedir).
export async function fetchMultiSetting(key, headers, defaultVal = []) {
  const v = await fetchRawSetting(key, headers);
  if (v == null) return defaultVal;
  const parts = v.split(',').map((s) => s.trim()).filter(Boolean);
  return parts;
}
